<template>
<div>
    <div class="invite-top-step">
        <el-steps :active="bidStep" align-center>
            <el-step>
                <span slot="title" @click="showType = 1">询标</span>
                <span slot="icon" style="display: block;height: 30px;width: 30px;line-height: 30px;cursor: pointer;" @click="showType = 1">1</span>
            </el-step>
            <el-step v-if="bidStep == 2">
                <span slot="title" @click="showType = 2">竞价</span>
                <span slot="icon" style="display: block;height: 30px;width: 30px;line-height: 30px;cursor: pointer;" @click="showType = 2">2</span>
            </el-step>
            <el-step v-else title="竞价"></el-step>
        </el-steps>
    </div>
    <!--询标-->
    <template v-if="showType == 1">
        <div class="table-box">
            <el-row class="table-head">
                <el-col :span="16" class="textLeft">询标报价参考价</el-col>
                <el-col :span="8" class="textRight">变更申请截止时间：{{endDate}}</el-col>
            </el-row>
            <el-row class="table-row" v-for="one in bidInfo.returnList || []" :key="one.id">
                <el-col :span="16" v-if="priceType == '5'" class="textLeft">付款比例：{{one.payRate || 0}}%，{{ lableName }}：{{( one.showData ) || 0}}元</el-col>
                <el-col :span="16" v-if="priceType == '1'" class="textLeft">{{ lableName }}：{{( one.showData ) || 0}}元</el-col>
                <el-col :span="16" v-if="['2', '3'].indexOf(priceType) > -1" class="textLeft">询标报价：{{( one.showData ) || 0}}</el-col>
                <el-col :span="16" v-if="priceType == '4'" class="textLeft">付款比例：{{one.payRate || 0}}%，{{( one.showData ) || 0}}</el-col>
                <el-col :span="8" class="textRight">
                    <el-button type="primary" size="mini" @click="$emit('nochange', one.id)" v-if="!checkDisabled(one.id)" :disabled="one.isNoChange == '1'">维持原价</el-button>
                    <el-button type="primary" size="mini" @click="$emit('open',one)" v-if="one.isNoChange != '1'" :disabled="checkDisabled(one.id)">变更申请</el-button>
                </el-col>
            </el-row>
            <div class="no-data-tip" v-if="!bidInfo.returnList || bidInfo.returnList.length == 0"></div>
        </div>
        <div class="table-box">
            <el-row class="table-head">
                <el-col :span="16" class="textLeft">变更申请信息</el-col>
                <el-col :span="8" class="textRight"></el-col>
            </el-row>
            <el-row class="table-row" v-for="one in bidInfo.changeReturnRecordList || []" :key="one.id">
                <el-col :span="16" v-if="priceType == '5'" class="textLeft">付款比例：{{one.payRate || 0}}%，变更{{ lableName }}：{{(isNewFlag ? one.noTax : one.totalPrice) || 0}}元</el-col>
                <el-col :span="16" v-if="priceType == '1'" class="textLeft">变更{{ lableName }}：{{(isNewFlag ? one.noTax : one.totalPrice) || 0}}元</el-col>
                <el-col :span="16" v-if="priceType == '2'" class="textLeft">变更报价：{{ floatTypeArray[one.floatFlag] + one.priceFloatRate + '%'}}</el-col>
                <el-col :span="16" v-if="priceType == '3'" class="textLeft">变更报价：{{ floatTypeArray[one.floatFlag] + one.floagMoney + priceUnit}}</el-col>
                <el-col :span="16" v-if="priceType == '4'" class="textLeft">付款比例：{{one.payRate || 0}}%，变更报价：{{ floatTypeArray[one.floatFlag] + one.priceFloatRate + '%'}}</el-col>
                <el-col :span="8" class="textRight">状态：{{one.status == 1 ? '通过' : one.status == 2 ? '驳回' : '已提交'}}</el-col>
            </el-row>
            <div class="no-data-tip" v-if="!bidInfo.changeReturnRecordList || bidInfo.changeReturnRecordList.length == 0"></div>
        </div>
    </template>
    <!--竞价-->
    <template v-if="showType == 2">
        <div class="table-box">
            <el-row class="table-row" v-for="one in bidInfo.returnList || []" :key="one.id">
                <el-col :span="16" v-if="priceType == '5'" class="textLeft">付款比例：{{one.payRate || 0}}%，询标{{ lableName }}：{{(isNewFlag ? one.noTax : one.totalPrice) || 0}}元</el-col>
                <el-col :span="16" v-if="priceType == '1'" class="textLeft">询标{{ lableName }}：{{(isNewFlag ? one.noTax : one.totalPrice) || 0}}元</el-col>
                <el-col :span="16" v-if="priceType == '2'" class="textLeft">询标报价：{{ floatTypeArray[one.floatFlag] + one.priceFloatRate + '%'}}</el-col>
                <el-col :span="16" v-if="priceType == '3'" class="textLeft">询标报价：{{ floatTypeArray[one.floatFlag] + one.floagMoney + priceUnit}}</el-col>
                <el-col :span="16" v-if="priceType == '4'" class="textLeft">付款比例：{{one.payRate || 0}}%，询标报价：{{ floatTypeArray[one.floatFlag] + one.priceFloatRate + '%'}}</el-col>
            </el-row>
        </div>

        <el-row :gutter="30" class="price-box">
            <template v-if="!bidInfo.setPriceList || bidInfo.setPriceList.length == 0">
                <el-col :span="24">
                    <el-card class="price-right">
                        <div v-bind:class="['price-right-tip','result']">竞价还未开始，敬请期待...</div>
                    </el-card>
                </el-col>
            </template>
            <template v-else>
                <el-col :span="12">
                    <el-card class="price-left">
                        <ul>
                            <li v-for="one in bidInfo.setPriceList || []" :key="one.id">
                                <template v-if="priceType == '1'">
                                    <label>{{one.batch}}轮竞价，{{ lableName }}</label>
                                    <span>{{(isNewFlag? one.notaxBusinessPrice : one.taxBusinessPrice) || 0}}元</span>
                                </template>

                                <template v-if="priceType == '2'">
                                    <label>{{one.batch}}轮竞价</label>
                                    <span>{{ !!one.priceFloatRate? (floatTypeArray[one.floatFlag] + one.priceFloatRate + '%,' + one.notaxBusinessPrice + priceUnit) : '未填写' }}</span>
                                </template>

                                <template v-if="priceType == '3'">
                                    <label>{{one.batch}}轮竞价，</label>
                                    <span>{{ !!one.floagMoney? (floatTypeArray[one.floatFlag] + one.floagMoney + priceUnit + ',' + one.notaxBusinessPrice + priceUnit) : '未填写' }}</span>
                                </template>

                                <template v-if="priceType == '4'">
                                    <label>{{one.batch}}轮竞价，付款比例{{one.payRate}}%</label>
                                    <span>{{ !!one.priceFloatRate? (floatTypeArray[one.floatFlag] + one.priceFloatRate + '%') : '未填写' }}</span>
                                </template>

                                <template v-if="priceType == '5'">
                                    <label>{{one.batch}}轮竞价，付款比例{{one.payRate}}%，{{ lableName }}</label>
                                    <span>{{(isNewFlag? one.notaxBusinessPrice : one.taxBusinessPrice) || 0}}元</span>
                                </template>
                                
                                <i class="fail" v-if="one.isBoult == 1">淘汰</i>
                                <i class="success" v-else-if="one.isBoult == 2">晋级下一轮</i>
                                <i class="success" v-else-if="one.isBoult == 4">成功</i>
                                <i class="orange" v-else-if="one.isBoult == 5 || !!isSubmitSuccess || !!isTimeEnd">竞价中</i>
                                <i class="grey" v-else>待提交</i>
                            </li>
                        </ul>
                    </el-card>
                </el-col>
                <el-col :span="12" style="padding-left: 0 !important;">
                    <el-card class="price-right">
                        <!--currentStatus 0-提交页 1-竞价失败 2-期待下一轮竞价 4-竞价成功 5-竞价中-->
                        <div v-if="currentStatus == 4" class="price-right-tip success">
                            <div class="text-div">
                                <i class="el-icon-success icon"></i>{{ tipMessage || '本次竞价贵公司顺利夺魁，恭喜您...' }}
                            </div>
                        </div>
                        <div v-if="currentStatus == 1" class="price-right-tip fail">
                            <div class="text-div">
                                <i class="el-icon-error icon"></i>{{ tipMessage || '本次竞价贵公司已经淘汰，期待您的下次参与...' }}
                            </div>
                        </div>
                        <div v-if="currentStatus == 5" class="price-right-tip result">
                            <div class="text-div">
                                <i class="el-icon-info icon"></i>{{ tipMessage || '竞价中...' }}
                            </div>
                        </div>
                        <div v-if="currentStatus == 2" class="price-right-tip success">
                            <div class="text-div">
                                <i class="el-icon-info icon"></i>{{ tipMessage || '敬请期待下一轮竞价...' }}
                            </div>
                        </div>
                        <div v-if="currentStatus == 0">
                            <div class="price-timer">倒计时 <span>{{countDown(endTime)}}</span></div>
                            <el-form label-width="100px" v-if="['1', '5'].indexOf(priceType) > -1" :model="priceForm" ref="priceForm" :rules="priceFormRules">
                                <el-form-item v-if="['4', '5'].indexOf(priceType) > -1" label="付款比例：">
                                    <div>{{priceForm.payRate1}}%</div>
                                </el-form-item>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="除税总价：" prop="notaxBusinessPrice1">
                                            <el-input size="medium" v-model="priceForm.notaxBusinessPrice1" placeholder="请输入除税总价(限整数)" clearable>
                                                <template slot="append">元</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="税率：" prop="tax1">
                                            <el-input size="medium" v-model="priceForm.tax1" placeholder="请输入税率" clearable>
                                                <template slot="append">%</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item label="含税总价：" prop="taxBusinessPrice1">
                                    <el-input size="medium" v-model="calculateTotalPrice1" readonly placeholder="含税价=除税价+除税价*税率">
                                        <template slot="append">元</template>
                                    </el-input>
                                </el-form-item>
                                <template v-if="priceForm.payRate2">
                                    <div style="width: 100%;border-bottom: 1px dashed #dcdddc"></div>
                                    <el-form-item label="付款比例：">
                                        <div>{{priceForm.payRate2}}%</div>
                                    </el-form-item>
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="除税总价：" prop="notaxBusinessPrice2">
                                                <el-input size="medium" v-model="priceForm.notaxBusinessPrice2" placeholder="请输入除税总价(限整数)" clearable>
                                                    <template slot="append">元</template>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="税率：" prop="tax2">
                                                <el-input size="medium" v-model="priceForm.tax2" placeholder="请输入税率" clearable>
                                                    <template slot="append">%</template>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-form-item label="含税总价：" prop="taxBusinessPrice2">
                                        <el-input size="medium" v-model="calculateTotalPrice2" readonly placeholder="含税价=除税价+除税价*税率">
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                </template>
                            </el-form>
                            <el-form label-width="100px" v-if="['2', '3', '4'].indexOf(priceType) > -1" :model="priceForm" ref="priceForm" :rules="tempRulesTwo">
                                <el-form-item v-if="['4', '5'].indexOf(priceType) > -1" label="付款比例：">
                                    <div>{{priceForm.payRate1}}%</div>
                                </el-form-item>

                                <template v-if="priceType != '4'">
                                    <el-form-item label="除税信息价：">
                                        <span>{{ infoPrice + priceUnit }}</span>
                                    </el-form-item>
                                    <el-form-item label="工程量：">
                                        <span>{{ quantities + quantitiesUnit }}</span>
                                    </el-form-item>
                                    <el-form-item label="说明：" prop="taxBusinessPrice1">
                                        <span>{{ priceDesc }}</span>
                                    </el-form-item>
                                </template>

                                <el-form-item label="浮动方式：" prop="floatFlag1">
                                    <el-radio-group v-model="priceForm.floatFlag1">
                                        <el-radio label="0">下浮</el-radio>
                                        <el-radio label="1">上浮</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                
                                <el-form-item v-if="['2', '4'].indexOf(priceType) > -1" label="浮动比率：" prop="priceFloatRate1">
                                    <el-input size="medium" v-model="priceForm.priceFloatRate1" placeholder="请输入浮动比率" clearable>
                                        <template slot="append">%</template>
                                    </el-input>
                                </el-form-item>

                                <el-form-item v-if="priceType == '3'" label="浮动金额：" prop="floagMoney1">
                                    <el-input size="medium" v-model="priceForm.floagMoney1" placeholder="请输入浮动金额" clearable>
                                        <template slot="append">{{ priceUnit }}</template>
                                    </el-input>
                                </el-form-item>

                                <el-form-item v-if="priceType != '4'" label="除税总价：" prop="notaxBusinessPrice1">
                                    <el-input size="medium" v-model="calculateTotalPrice3" readonly :placeholder="holderTitleCol">
                                        <template slot="append">{{ priceUnit }}</template>
                                    </el-input>
                                </el-form-item>
                                <template v-if="priceForm.payRate2">
                                    <div style="width: 100%;border-bottom: 1px dashed #dcdddc"></div>
                                    
                                    <el-form-item label="付款比例：">
                                        <div>{{priceForm.payRate2}}%</div>
                                    </el-form-item>

                                    <el-form-item label="浮动方式：" prop="floatFlag2">
                                        <el-radio-group v-model="priceForm.floatFlag2">
                                            <el-radio label="0">下浮</el-radio>
                                            <el-radio label="1">上浮</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    
                                    <el-form-item label="浮动比率：" prop="priceFloatRate2">
                                        <el-input size="medium" v-model="priceForm.priceFloatRate2" placeholder="请输入浮动比率" clearable>
                                            <template slot="append">%</template>
                                        </el-input>
                                    </el-form-item>                                                    
                                </template>
                            </el-form>
                            <div class="text-center">
                                <el-button type="primary" size="medium" @click="checkPriceForm" :loading="submitLoading" :disabled="isDisabled">提 交</el-button>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </template>
        </el-row>
        <el-dialog title="竞价确认" :visible.sync="confirmDialog" center width="700px" @close="handleDialogClose" :close-on-click-modal="false" :close-on-press-escape="false">
            <!-- 总价 -->
            <div class="confirmDialog" v-if="priceType == '1'">
                <div class="title-div"><b>{{ lableName }}为</b></div>
                <div class="amount-div">{{ isNewFlag ? amountConversionText(priceForm.notaxBusinessPrice1) : amountConversionText(priceForm.taxBusinessPrice1)}}</div>

                <div class="num-div">{{countDown(endTime)}}</div>
            </div>

            <!-- 浮动比率+总价 或 浮动金额+总价 -->
            <div class="confirmDialog" v-if="['2', '3'].indexOf(priceType) > -1 ">
                <div class="title-div"><b>{{ floatTypeArray[priceForm.floatFlag1] + (priceType == '2' ? (priceForm.priceFloatRate1 + '%') : (priceForm.floagMoney1 + priceUnit)) }}为</b></div>
                <div class="amount-div">{{floatConversionText(priceForm.notaxBusinessPrice1) + (priceUnit == '元' ?  '' : priceUnit)}}</div>
                <div class="num-div">{{countDown(endTime)}}</div>
            </div>

             <!-- 付款比例+浮动比率 -->
            <div class="confirmDialog" v-if="priceType == '4'">
                <div class="title-div">付款比例{{priceForm.payRate1}}%，
                    <b>{{ floatTypeArray[priceForm.floatFlag1] + priceForm.priceFloatRate1 + '%' }}</b>
                </div>
                <template v-if="priceForm.payRate2">
                    <div class="title-div">付款比例{{priceForm.payRate2}}%，
                        <b><b>{{ floatTypeArray[priceForm.floatFlag2] + priceForm.priceFloatRate2 + '%' }}</b></b>
                    </div>
                </template>
                <div class="num-div">{{countDown(endTime)}}</div>
            </div>

            
            <!-- 付款比例 + 总价 -->
            <div class="confirmDialog" v-if="priceType == '5'">
                <div class="title-div">付款比例{{priceForm.payRate1}}%，<b>{{ lableName }}为</b></div>
                <div class="amount-div">{{amountConversionText(priceForm.taxBusinessPrice1)}}</div>
                <template v-if="priceForm.payRate2">
                    <div class="title-div">付款比例{{priceForm.payRate2}}%，<b>{{ lableName }}为</b></div>
                    <div class="amount-div">{{amountConversionText(priceForm.taxBusinessPrice2)}}</div>
                </template>
                <div class="num-div">{{countDown(endTime)}}</div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="savePrice" :loading="submitLoading" :disabled="isDisabled">提 交</el-button>
                <el-button type="default" size="small" @click="handleDialogClose" :disabled="submitLoading">取 消</el-button>
            </div>
        </el-dialog>
    </template>
</div>
</template>

<script>
    const moment = require('moment');
    export default {
        name: "BidNumBox",
        props: {
            bidInfo: Object,
            endDate: String,
            bidStep: [String,Number],
            open: Function,
            isNewFlag: Boolean,
            lableName: String,
            priceType: String,
            priceUnit: String,
            infoPrice: String,
            quantities: String,
            quantitiesUnit: String,
            priceDesc: String
        },
        data(){
            return {
                priceForm: {
                    id1: '',
                    payRate1: '',
                    notaxBusinessPrice1: '',
                    tax1: '',
                    taxBusinessPrice1: '',
                    oldTaxBusinessPrice1: '',
                    priceFloatRate1: null,
                    floatFlag1: null,
                    floagMoney1: null,
                    /*第二个比例*/
                    id2: '',
                    payRate2: '',
                    notaxBusinessPrice2: '',
                    tax2: '',
                    taxBusinessPrice2: '',
                    oldTaxBusinessPrice2: '',
                    priceFloatRate2: null,
                    floatFlag2: null,
                    floagMoney2: null
                },
                priceFormRules: {
                    notaxBusinessPrice1: [
                        { required: true, message: '除税总价不能为空', trigger: 'change' },
                        { validator: this.checkNumber1, trigger: 'blur' }
                    ],
                    tax1: [
                        { required: true, message: '税率不能为空',trigger: 'change' },
                        { validator: this.checkRate, trigger: 'change' }
                    ],
                    taxBusinessPrice1: [
                        { required: true, message: '含税总价不能为空',trigger: 'change' },
                        { validator: this.checkPrice1, trigger: 'change' }
                    ],
                    notaxBusinessPrice2: [
                        { required: true, message: '除税总价不能为空', trigger: 'change' },
                        { validator: this.checkNumber2, trigger: 'blur' }
                    ],
                    tax2: [
                        { required: true, message: '税率不能为空',trigger: 'change' },
                        { validator: this.checkRate, trigger: 'change' }
                    ],
                    taxBusinessPrice2: [
                        { required: true, message: '含税总价不能为空',trigger: 'change' },
                        { validator: this.checkPrice2, trigger: 'change' }
                    ]
                },
                currentTime: '',
                endTime: '',
                confirmDialog: false,
                submitLoading: false,
                IntervalObj: '',
                isTimeEnd: false,
                isSubmitSuccess: false,
                currentStatus: '', // 0-提交页 1-竞价失败 2-期待下一轮竞价 4-竞价成功 5-竞价中
                tipMessage: '',
                showType: '', //1-询标 2-竞价
                floatTypeArray: ['下浮', '上浮'],
                tempRulesTwo: {},
                holderTitle: ''
            }
        },
        created() {
            this.showType = (this.bidStep == 1) ? '1' : '2';
            let arr = this.bidInfo.setPriceList || [];
            if(arr.length){
                let payRateStatusJson = {};
                let showMessageDatas = [];
                arr.forEach(one=>{
                    if(!!one.showMsg) showMessageDatas.push(one);
                    if(!payRateStatusJson[one.payRate]){
                        payRateStatusJson[one.payRate] = {
                            status: [one.isBoult || '0'],
                            list: [one]
                        }
                    }else {
                        payRateStatusJson[one.payRate].status.push(one.isBoult || '0');
                        payRateStatusJson[one.payRate].list.push(one);
                    }
                });
                let statusArr = [];
                let failedStatusArr = [];
                for(let key in payRateStatusJson){
                    failedStatusArr.push(payRateStatusJson[key].status.indexOf('1') !== -1 ? 'true':'false');
                    statusArr = statusArr.concat(payRateStatusJson[key].status);  //两种付款比例状态值汇总;
                }
                if(statusArr.indexOf('0') !== -1){
                    /*未提交*/
                    this.currentStatus = '0';
                }else if(statusArr.indexOf('5') !== -1){
                    /*竞价中*/
                    this.currentStatus = '5';
                    let row = showMessageDatas.find(one=>{return one.isWinFlag == 1});
                    this.tipMessage = row ? row.showMsg : !!showMessageDatas.length ? showMessageDatas[0].showMsg : '';
                }else if(statusArr.indexOf('4') !== -1){
                    /*竞价成功*/
                    this.currentStatus = '4';
                    this.tipMessage = !!showMessageDatas.length ? showMessageDatas[0].showMsg : '';
                }else if(failedStatusArr.indexOf('false') !== -1){
                    /*只要不同时存在淘汰的情况就视为晋级下一轮*/
                    this.currentStatus = '2';
                }else {
                    //两种比例多轮竞价都被淘汰才真正淘汰
                    this.currentStatus = '1';
                    this.tipMessage = !!showMessageDatas.length ? showMessageDatas[0].showMsg : '';
                }
                /*第一条竞价数据的状态是未提交才显示倒计时*/
                if(!arr[0].isBoult && !!arr[0].businessStartDate){
                    this.currentTime = moment(arr[0].currentTime || '').format('YYYY-MM-DD HH:mm:ss');
                    this.endTime = moment(arr[0].businessStartDate).add(arr[0].priceTime || 0, 'minutes').format('YYYY-MM-DD HH:mm:ss');
                    this.IntervalObj = setInterval(()=>{
                        this.currentTime = moment(this.currentTime).add(1000, 'milliseconds').format('YYYY-MM-DD HH:mm:ss');
                    },1000);
                    this.priceForm.payRate1 = arr[0].payRate;
                    this.priceForm.id1 = arr[0].id;
                    this.priceForm.oldTaxBusinessPrice1 = arr[0].oldTaxBusinessPrice || 0;
                    if(arr[1]){
                        if(arr[1].batch == arr[0].batch){
                            this.priceForm.payRate2 = arr[1].payRate;
                            this.priceForm.id2 = arr[1].id;
                            this.priceForm.oldTaxBusinessPrice2 = arr[1].oldTaxBusinessPrice || 0;
                        }
                    }
                }
            }

            this.setTempRulesFun()
        },
        computed: {
            isDisabled(){
                if(this.countDown(this.endTime) === "00:01:00") this.$message.warning('竞价还剩最后一分钟，请尽快提交竞价金额');
                if(this.countDown(this.endTime) === "00:00:00") this.$message.warning('本轮竞价已结束');
                return this.countDown(this.endTime) === "00:00:00";
            },
            calculateTotalPrice1() {
                if(!!this.priceForm.notaxBusinessPrice1 && !!this.priceForm.tax1){
                    let tempPrice = this.priceForm.notaxBusinessPrice1 * (1000000 + parseInt(this.priceForm.tax1 * 10000)) / 1000000;
                    this.priceForm.taxBusinessPrice1 = parseFloat(tempPrice).toFixed(2)
                }else {
                    this.priceForm.taxBusinessPrice1 = '';
                }
                return this.priceForm.taxBusinessPrice1;
            },
            calculateTotalPrice2() {
                if(!!this.priceForm.notaxBusinessPrice2 && !!this.priceForm.tax2){
                    let tempPrice = this.priceForm.notaxBusinessPrice2 * (1000000 + parseInt(this.priceForm.tax2 * 10000)) / 1000000;
                    this.priceForm.taxBusinessPrice2 = parseFloat(tempPrice).toFixed(2)
                }else {
                    this.priceForm.taxBusinessPrice2 = '';
                }
                return this.priceForm.taxBusinessPrice2;
            },
            calculateTotalPrice3() {
                if (this.priceType == '2') {
                    if (!!this.priceForm.priceFloatRate1) {
                        // '除税信息价*工程量*（1+上浮比例）'
                        if (this.priceForm.floatFlag1 == '0') {
                            // 下浮
                            let tempPrice = ((Number(this.infoPrice) * 100) * (Number(this.quantities) * 100) * (10000 - (Number(this.priceForm.priceFloatRate1) * 100))) / 100000000
                            this.priceForm.notaxBusinessPrice1 = parseFloat(tempPrice).toFixed(2)
                        } else if (this.priceForm.floatFlag1 == '1') {
                            // 上浮
                            let tempPrice = ((Number(this.infoPrice) * 100) * (Number(this.quantities) * 100) * (10000 + (Number(this.priceForm.priceFloatRate1) * 100))) / 100000000
                            this.priceForm.notaxBusinessPrice1 = parseFloat(tempPrice).toFixed(2)
                        } else {
                            this.priceForm.notaxBusinessPrice1 = ''
                        }
                    } else {
                        this.priceForm.notaxBusinessPrice1 = ''
                    }
                    
                } else if (this.priceType == '3') {
                    if (!!this.priceForm.floagMoney1) {
                        // '除税价=除税价+上浮的浮动金额'
                        if (this.priceForm.floatFlag1 == '0') {
                            // 下浮
                            let tempPrice = (((Number(this.infoPrice) * 100) * (Number(this.quantities) * 100)) - (Number(this.priceForm.floagMoney1) * 10000)) / 10000
                            this.priceForm.notaxBusinessPrice1 = parseFloat(tempPrice).toFixed(2)
                        } else if (this.priceForm.floatFlag1 == '1') {
                            // 上浮
                            let tempPrice = (((Number(this.infoPrice) * 100) * (Number(this.quantities) * 100)) + (Number(this.priceForm.floagMoney1) * 10000)) / 10000
                            this.priceForm.notaxBusinessPrice1 = parseFloat(tempPrice).toFixed(2)
                        } else {
                            this.priceForm.notaxBusinessPrice1 = ''
                        }
                    } else {
                        this.priceForm.notaxBusinessPrice1 = ''
                    }
                } else {
                    this.priceForm.notaxBusinessPrice1 = ''
                }
                return this.priceForm.notaxBusinessPrice1
            },
            countDown(){
                return function(endDate) {
                    let m1 = moment(this.currentTime);
                    let m2 = moment(endDate);
                    let du = moment.duration(m2 - m1, 'ms');
                    let hh = du.get('hours');
                    let mm = du.get('minutes');
                    let ss = du.get('seconds');
                    if(hh<=0 && mm<=0 && ss<=0) {
                        clearInterval(this.IntervalObj);
                        this.isTimeEnd = true;
                        return "00:00:00"
                    }else {
                        this.isTimeEnd = false;
                        return this.prefixInteger(hh,2) + ':' + this.prefixInteger(mm,2) + ':' + this.prefixInteger(ss,2)
                    }
                }
            },
            holderTitleCol () {
                // 根据类型和浮动比率显示
                let temp = ''

                if (this.priceForm.floatFlag1 == '1') {
                    temp = "+"
                } else {
                    temp = "-"
                }

                this.holderTitle = this.priceType == '2' ? '除税信息价*工程量*(1' + temp + '上浮比例)' : '除税价=(除税信息价*工程量) ' + temp + ' 浮动金额'

                return this.holderTitle
            }
        },
        methods: {
            /*补零函数*/
            prefixInteger(num, n) {
                return (Array(n).join(0) + num).slice(-n);
            },
            /*金额转换文字*/
            amountConversionText(n) {
                if (n == 0) return "零";
                if (!/^(\+|-)?(0|[1-9]\d*)(\.\d+)?$/.test(n)) return "数据非法";

                var unit = "仟佰拾亿仟佰拾万仟佰拾元角分", str = "";

                n += "00";
                var a = parseFloat(n);
                if (a < 0) {
                    n = n.substr(1);
                }
                var p = n.indexOf('.');
                if (p >= 0) {
                    n = n.substring(0, p) + n.substr(p + 1, 2);
                }

                unit = unit.substr(unit.length - n.length);

                for (var i = 0; i < n.length; i++)
                    str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
                if (a > 0) {
                    return str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元").replace(/\s/g, '');
                } else {
                    return "负" + str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元").replace(/\s/g, '');
                }
            },
            floatConversionText (n) {
                if (n == 0) return "零";
                if (!/^(\+|-)?(0|[1-9]\d*)(\.\d+)?$/.test(n)) return "数据非法";

                var unit = "仟佰拾亿仟佰拾万仟佰拾元角分", str = "";

                if (this.priceUnit != '元') {
                    if (String(n).indexOf('.') > -1) {
                        unit = "仟佰拾亿仟佰拾万仟佰拾点  "
                    } else {
                        unit = "仟佰拾亿仟佰拾万仟佰拾   "
                    }
                }

                n += "00";
                var a = parseFloat(n);
                if (a < 0) {
                    n = n.substr(1);
                }
                var p = n.indexOf('.');
                if (p >= 0) {
                    n = n.substring(0, p) + n.substr(p + 1, 2);
                }

                unit = unit.substr(unit.length - n.length);

                for (var i = 0; i < n.length; i++)
                    str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
                if (a > 0) {
                    return str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零\s/g, '').replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元").replace(/\s/g, '');
                } else {
                    return "负" + str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零\s/g, '').replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元").replace(/\s/g, '').replace(/\s/g, '');
                }
            },
            checkDisabled(id){
                if(this.bidStep != 1) return true;
                let list = this.bidInfo.changeReturnRecordList || [];
                let index = list.findIndex(one=>{return one.returnId === id});
                return index !== -1;
            },
            checkPriceForm(){
                this.$refs['priceForm'].validate((valid)=>{
                    if(valid){
                        this.confirmDialog = true;
                    }
                })
            },
            savePrice(){
                if(this.submitLoading) return;
                let list = [];
                
                list.push({
                    id: this.priceForm.id1,
                    notaxBusinessPrice: Number(this.priceForm.notaxBusinessPrice1),
                    tax: this.priceForm.tax1,
                    taxBusinessPrice: this.priceForm.taxBusinessPrice1,
                    priceFloatRate: this.priceForm.priceFloatRate1,
                    floatFlag: this.priceForm.floatFlag1,
                    floagMoney: this.priceForm.floagMoney1
                })

                if(this.priceForm.payRate2){
                    list.push({
                        id: this.priceForm.id2,
                        notaxBusinessPrice: this.priceForm.notaxBusinessPrice2,
                        tax: this.priceForm.tax2,
                        taxBusinessPrice: this.priceForm.taxBusinessPrice2,
                        priceFloatRate: this.priceForm.priceFloatRate2,
                        floatFlag: this.priceForm.floatFlag2,
                        floagMoney: this.priceForm.floagMoney2
                    })
                }
                this.submitLoading = true;
                this.$http.post('rest/api/independentPrice/inquiry/updatePrice', list).then((res) => {
                    this.submitLoading = false;
                    if (res.data.result) {
                        this.$message.success('提交成功');
                        this.handleDialogClose();
                        this.$emit('callback');
                    }else {
                        this.$message.error('提交失败');
                    }
                }).catch(()=>{
                    this.submitLoading = false;
                    this.$message.error('提交失败');
                })
            },
            handleDialogClose(){
                this.confirmDialog = false;
            },
            checkNumber1 (rule, value, callback) {
                if (!value) {
                    return callback(new Error('除税总价不能为空'));
                } else if (!value.match(/^[0-9]*$/)) {
                    callback(new Error('请输入整数'));
                } else {
                    if (this.isNewFlag) {
                        if(!this.priceForm.oldTaxBusinessPrice1){
                            callback();
                        }else if (value < this.priceForm.oldTaxBusinessPrice1 * 0.1) {
                            callback(new Error('除税价不能低于上一轮报价的10%'));
                        } else if(value > this.priceForm.oldTaxBusinessPrice1){
                            callback(new Error('除税价不能高于上一轮报价'));
                        }else {
                            callback();
                        }
                    } else {
                        callback();
                    }
                }
            },
            checkNumber2 (rule, value, callback) {
                if (!value) {
                    return callback(new Error('除税总价不能为空'));
                } else if (!value.match(/^[0-9]*$/)) {
                        callback(new Error('请输入整数'));
                } else {
                    if (this.isNewFlag) {
                        if(!this.priceForm.oldTaxBusinessPrice2){
                            callback();
                        }else if (value < this.priceForm.oldTaxBusinessPrice2 * 0.1) {
                            callback(new Error('含税总价不能低于上一轮报价的10%'));
                        } else if(value > this.priceForm.oldTaxBusinessPrice2){
                            callback(new Error('含税总价不能高于上一轮报价'));
                        }else {
                            callback();
                        }
                    } else {
                        callback();
                    }
                }
            },
            checkRate (rule, value, callback) {
                if (!value) {
                    return callback(new Error('税率不能为空'));
                }
                setTimeout(() => {
                    if (!value.match(/^\d+(\.\d{1,2})?$/)) {
                        callback(new Error('税率范围0-100'));
                    } else if(value > 100){
                        callback(new Error('税率范围0-100'));
                    }else {
                        callback();
                    }
                }, 20);
            },
            checkPrice1 (rule, value, callback) {
                if (!value) {
                    return callback(new Error('含税总价不能为空'));
                } else {
                    if (!this.isNewFlag) {
                        if(!this.priceForm.oldTaxBusinessPrice1){
                            callback();
                        }else if (value < this.priceForm.oldTaxBusinessPrice1 * 0.1) {
                            callback(new Error('含税总价不能低于上一轮报价的10%'));
                        } else if(value > this.priceForm.oldTaxBusinessPrice1){
                            callback(new Error('含税总价不能高于上一轮报价'));
                        }else {
                            callback();
                        }
                    } else {
                        callback();
                    }
                }
            },
            checkPrice2 (rule, value, callback) {
                if (!value) {
                    return callback(new Error('含税总价不能为空'));
                } else {
                    if (!this.isNewFlag) {
                        if(!this.priceForm.oldTaxBusinessPrice2){
                            callback();
                        }else if (value < this.priceForm.oldTaxBusinessPrice2 * 0.1) {
                            callback(new Error('含税总价不能低于上一轮报价的10%'));
                        } else if(value > this.priceForm.oldTaxBusinessPrice2){
                            callback(new Error('含税总价不能高于上一轮报价'));
                        }else {
                            callback();
                        }
                    } else {
                        callback();
                    }
                }
            },
            setTempRulesFun () {
                this.tempRulesTwo = {}
                this.tempRulesTwo.floatFlag1 =  [
                    { required: true, message: '浮动类型必须选择', trigger: 'change' }
                ]
                this.tempRulesTwo.floatFlag2 =  [
                    { required: true, message: '浮动类型必须选择', trigger: 'change' }
                ]

                if (this.priceType == '3') {
                    this.tempRulesTwo.floagMoney1 = [
                        { required: true, message: '浮动金额必须填写', trigger: 'change' },
                        { validator: (rule, value, callback) => {
                            // 需要判断金额大于0 判断是否是数字
                            if (isNaN(Number(this.priceForm.floagMoney1))) {
                                callback(new Error('浮动金额必须填写数字'));
                            } else if (this.priceForm.floagMoney1 < 0) {
                                callback(new Error('浮动金额必须不小于0'));
                            } else {
                                let tempArray = this.priceForm.floagMoney1.split('.')

                                if (tempArray.length > 1 && tempArray[tempArray.length - 1].length > 2) {
                                    callback(new Error('浮动金额最多两位小数'));
                                } else if (Number(this.priceForm.notaxBusinessPrice1) > this.priceForm.oldTaxBusinessPrice1) {
                                    // 浮动价格必须小于
                                    callback(new Error('报价价格不得大于上一轮报价（或询标报价）'));
                                } else {
                                    callback();
                                }
                            }
                        }, trigger: 'blur' }
                    ]
                }
                if (['2', '4'].indexOf(this.priceType) > -1) {
                    this.tempRulesTwo.priceFloatRate1 = [
                        { required: true, message: '浮动比率必须填写', trigger: 'change' },
                        { validator: (rule, value, callback) => {
                            // 需要判断需要判断数字并且大于0
                            if (isNaN(Number(this.priceForm.priceFloatRate1))) {
                                callback(new Error('浮动比率必须填写数字'));
                            } else if (this.priceForm.priceFloatRate1 < 0) {
                                callback(new Error('浮动比率必须不小于0'));
                            } else {
                                let tempArray = this.priceForm.priceFloatRate1.split('.')

                                if (tempArray.length > 1 && tempArray[tempArray.length - 1].length > 2) {
                                    callback(new Error('浮动金额最多两位小数'));
                                } else {
                                    if (this.priceType == '2') {
                                        if (this.priceForm.notaxBusinessPrice1 > this.priceForm.oldTaxBusinessPrice1) {
                                            callback(new Error('报价价格不得大于上一轮报价（或询标报价）'));
                                        } else {
                                            callback()
                                        }
                                    } else {
                                        let tempRate = ('1' == this.priceForm.floatFlag1 ? 1 : -1) * this.priceForm.priceFloatRate1 * 100
                                        if (tempRate > (this.priceForm.oldTaxBusinessPrice1 * 100)) {
                                            callback(new Error('报价价格不得大于上一轮报价（或询标报价）'));
                                        } else {
                                            callback()
                                        }
                                    }
                                }
                            }
                        }, trigger: 'blur' }
                    ]

                    this.tempRulesTwo.priceFloatRate2 = [
                        { required: true, message: '浮动比率必须填写', trigger: 'change' },
                        { validator: (rule, value, callback) => {
                            // 需要判断需要判断数字并且大于0
                            if (isNaN(Number(this.priceForm.priceFloatRate2))) {
                                callback(new Error('浮动比率必须填写数字'));
                            } else if (this.priceForm.priceFloatRate2 < 0) {
                                callback(new Error('浮动比率必须不小于0'));
                            } else {
                                let tempArray = this.priceForm.priceFloatRate2.split('.')

                                if (tempArray.length > 1 && tempArray[tempArray.length - 1].length > 2) {
                                    callback(new Error('浮动金额最多两位小数'));
                                } else {
                                    if (this.priceType == '2') {
                                        if (this.priceForm.notaxBusinessPrice2 > this.priceForm.oldTaxBusinessPrice2) {
                                            callback(new Error('报价价格不得大于上一轮报价（或询标报价）'));
                                        } else {
                                            callback()
                                        }
                                    } else {
                                        let tempRate = ('1' == this.priceForm.floatFlag2 ? 1 : -1) * this.priceForm.priceFloatRate2 * 100
                                        if (tempRate > (this.priceForm.oldTaxBusinessPrice2 * 100)) {
                                            callback(new Error('报价价格不得大于上一轮报价（或询标报价）'));
                                        } else {
                                            callback()
                                        }
                                    }
                                }
                            }
                        }, trigger: 'blur' }
                    ]
                }
            }
        }
    }
</script>

<style scoped lang="postcss">
    .confirmDialog {
        font-size: 20px;
        text-align: center;
        color: #333333;
    }
    .confirmDialog .title-div{
        margin-bottom: 10px;
    }
    .confirmDialog .amount-div{
        color: #f28718;
        font-size: 30px;
        margin-bottom: 20px;
    }
    .confirmDialog .num-div{
        color: #f28718;
        font-size: 30px;
        padding-top: 20px;
    }
    ul {
        padding: 0;
        margin: 0;
    }

    ul li {
        list-style: none;
    }
    .invite-top-step {
        margin-bottom: 20px;
        padding-top: 20px;
        height: 80px;
        background: #f5f5f5;
    }
    .table-box {
        margin-top: 30px;
        border: 1px solid #f5f5f5;
    }

    .table-box .table-head {
        background-color: #f5f5f5;
        padding: 0 10px;
        height: 35px;
        line-height: 35px;
        font-size: 12px;
    }

    .table-box .table-row {
        border-top: 1px solid #f5f5f5;
        padding: 0 10px;
        height: 45px;
        line-height: 45px;
        font-size: 12px;
    }

    .table-box .textLeft {
        text-align: left;
        padding-bottom: 0;
    }

    .table-box .textRight {
        text-align: right;
        padding-bottom: 0;
    }

    .price-box {
        border-top: 1px dashed #dcdddc;
        padding: 20px 0;
    }

    .price-box .price-left,
    .price-box .price-right {
        box-shadow: none;
        vertical-align: top;
        min-height: 500px;
    }

    .price-box .price-left ul li + li {
        margin-top: 50px;
    }

    .price-box .price-left ul li + li:before {
        position: absolute;
        display: inline-block;
        content: '';
        width: 4px;
        height: 50px;
        background: #DFE3E7;
        margin-left: 7px;
        margin-top: -51px;
    }

    .price-box .price-left ul li label {
        padding-left: 30px;
        font-weight: 700;
    }

    .price-box .price-left ul li label:before {
        position: absolute;
        display: inline-block;
        content: "";
        width: 12px;
        height: 12px;
        border-radius: 12px;
        margin-left: -30px;
        margin-top: 3px;
        background: #f28718;
        border: 3px solid #ffecc5;
    }

    .price-box .price-left ul li span {
        color: #f28718;
        font-weight: 700;
        font-size: 18px;
    }

    .price-box .price-left ul li i {
        display: inline-block;
        padding: 2px 8px;
        border-radius: 4px;
        font-style: normal;
        font-size: 12px;
        color: #fff;
    }

    .price-box .price-left ul li i.fail {
        background: #f45454;
    }

    .price-box .price-left ul li i.success {
        background: #58bb7e;
    }

    .price-box .price-left ul li i.grey {
        background: #999999;
    }

    .price-box .price-left ul li i.orange {
        background: #f28718;
    }

    .price-timer {
        text-align: center;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .price-timer span {
        color: #f28718;
    }

    .price-box .price-right .price-timer {
        font-size: 20px;
    }

    .price-right-tip {
        min-height: 240px;
        font-size: 18px;
        font-weight: bold;
    }
    .price-right-tip .text-div{
        line-height: 20px;
    }
    .price-right-tip .text-div .icon{
        font-size: 25px;
        margin-right: 10px;
        vertical-align: text-bottom;
    }

    .price-right-tip.success {
        color: #58bb7e;
    }

    .price-right-tip.fail {
        color: #f45454;
    }

    .price-right-tip.result {
        color: #F28718;
    }

</style>



// WEBPACK FOOTER //
// src/pages/dsp/invite/components/BidNumBox.vue